import { isElectronApp } from '../services/crossPlatform/crossPlatformService';

const ipcRenderer = isElectronApp() && window.require('electron').ipcRenderer;

export const loadSmartWindowAndHideMainWindow = (bookId, url) => {
  ipcRenderer.send('hide-main-window');
  openSmartWindow(bookId, url);
};

export const openWebViewWindow = (activityId, url) => {
  ipcRenderer.send('open-webview-content', { activityId, url });
};

export const openSmartWindow = (activityId, url) => {
  ipcRenderer.send('open-smart-content', { activityId, url });
};

export const notifyAuthory = (activityId, Payload) => {
  ipcRenderer.send('window-has-authory', { activityId, Payload });
};

export const notifyDisconnection = () => {
  ipcRenderer.send('network-has-disconnected');
};

export const reloadApp = () => {
  ipcRenderer.send('reload-app');
};

export const openCookiesDetail = cookieDetailsURL => {
  ipcRenderer.send('open-cookies-detail', cookieDetailsURL);
};

export const openStatusPage = statusPageURL => {
  ipcRenderer.send('open-status-page', statusPageURL);
};
